module.exports = __webpack_public_path__ + "05_glasses_red.c23c8aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/05_glasses_red.png
// module id = 1jAe
// module chunks = 0